import { ActionType } from '../../../core/redux/actionType';
import { makeApiAction, makeRsaaTypes, ApiReducer, makeApiReducer } from '../../../core/api/rsaa';
import { Endpoints } from '../../../core/api/endpoints';
import { getLoading, addLoading, addError, noLoadingNoError } from '../../../core/api/module';
import * as R from 'ramda';
import { Report } from '../models';


const KEY_ACTION = ActionType.LoadReportsRequest;
const ACTIONS    = [
  ActionType.LoadReportsRequest,
  ActionType.LoadReportsResponse,
  ActionType.LoadReportsError,
];


type Payload = Report[];
type Meta = { projectId: number; }


/**
 * Dispatch this action to load the list of reports associated with a specific person
 */
export const loadReportsAction = (
  projectId: number,
  participantId: number,
  userName: string,
) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.ViewReports,
  headers:  { 'content-type': 'application/json' },
  body: (state) => (JSON.stringify({
    projectId: projectId,
    participantId: participantId,
    userName: userName,
  })),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { projectId }),
  bailout:  state => !!getLoading(state, KEY_ACTION),
});


const reducer: ApiReducer<Payload> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  return R.assoc('reports', payload, successState);
};


export const loadReportsReducer = makeApiReducer<Payload>(ACTIONS, KEY_ACTION, reducer);
